import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { TextArea } from '../../../../components/form-elements/TextArea';
import { ShipmentExportDocument } from '../../../../models/production/shipment-export-document';

export const ShipmentExport = () =>  {

    const [isOpen, setIsOpen] = React.useState(false);
    const [shipmentIds, setShipmentIds] = React.useState('');
    const dispatch = useDispatch();
    
    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setShipmentIds('');
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the run credit report command
     */
    const runReport = () => {
        
        if (shipmentIds && shipmentIds.length > 0) {    
            
            const idList = shipmentIds.split('\n');
            const idListStr = idList.reduce((accum : string, curr : string) => {

                const parseResult = Number.parseInt(curr, 10);
                if (isNaN(parseResult)) {
                    return accum;                    
                }
                else {
                    return accum += curr + ',';
                }        
            }, '');
            
            const req = new ShipmentExportDocument(idListStr.substr(0, idListStr.length - 1));
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    /**
     * Handler for changing the cutoff date.
     * @param newDate The new cutoff date as chosen 
     */
    const onShipmentIdChange = (e : any) => {    
        setShipmentIds(e.target.value);
    };

    return <React.Fragment>
        <div className="report-card-wrap blue">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>Shipment Export</h3>
                            <p>Export orders for a list of shipments.</p>
                        </div>
                    </div>
                
                    <div className="row">
                        <div className="col">
                        <DialogTrigger
                            onClick={ onOpenClick }
                            text="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={ isOpen }
            className="report-dialog"
            onClose={ onCloseClick }
            maxWidth="md"
            aria-labelledby="form-dialog-title">

            <DialogHeader>
                <h1>Shipment Export</h1>
            </DialogHeader>

            <DialogContent>
                <div className="row">
                    <div className="col">
                        <p>Provide a list shipment IDs, one per line, to export a list of all the orders on those shipments.</p>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <TextArea
                            id="shipmentIds"
                            className="reporting-shipmentexport-textarea"
                            label="Shipment IDs"
                            allowReturn={ true }
                            value={ shipmentIds }
                            onChange={ onShipmentIdChange } />
                    </div>
                </div>    
            </DialogContent>
            <DialogActions>
                <FlatButton
                    id="accountmateNoBtn"
                    text="Cancel"
                    classes="negative"
                    onBtnClick={ onCloseClick } />
                <FlatButton
                    id="accountmateYesBtn"
                    text="Go"
                    disable={ shipmentIds.length === 0 }
                    classes="positive"
                    onBtnClick={ runReport } />
            </DialogActions>
        </Dialog>
    </React.Fragment>;

};
